<google-map
  height="28vh"
  width="100%"
  [options]="options"
  [center]="center()"
  [zoom]="zoom">

  @for (item of getValidContacts(); track item.contact) {
    <map-marker
      [position]="item.position"
      [options]="item.contact === contactSelected() ? markerOptionsActive : markerOptions"
      [style.filter]="item.contact === contactSelected() ? 'grayscale' : 'none'"
      (mapClick)="onMarkerClick(item.contact)" />
  }

  @if (ownPosition()) {
    <map-marker [position]="ownPosition()"
      [options]="markerOptionsOwnPosition" />
  }

</google-map>
